import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Language } from 'src/app/models/language.model';
import { List } from '../../models/list.model';
import { ConfigService } from 'src/app/core/services/config-service';

@Injectable()
export class LanguageService {
  constructor(private http: HttpClient) {}

  configService = inject(ConfigService);

  getLanguages(): Observable<List<Language>> {
    const url = this.configService.readConfig().baseUrlInfrastructure + '/language?PageSize=999999';
    return this.http.get<List<Language>>(url);
  }
}
